export default {
      id: "i-graduation-cap-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "img/sprite.svg#i-graduation-cap",
      toString: function () {
        return this.url;
      }
    }